<template>
  <div class="majors-list">
    <div class="majors-toggle-archived banner">
      <div class="row">
        <div class="academic-period-display">
          <div class="period-label">Academic Year</div>
          <h2 v-if="!showArchived">{{ currentPeriod.academic_year }}</h2>
          <h2 v-if="showArchived">All Academic Years</h2>
        </div>
        <span>
          <button @click = 'toggleArchived' class = 'hollow'>
            {{ showArchived ? "Hide Previous Years" : "Show Previous Years" }}
          </button>
        </span>
      </div>
      <p v-if="!showArchived" class="info">Listing degrees for the current academic year ({{ currentPeriod.academic_year }}). If you do not see the plan you are looking for, you may toggle archived years using the button to the right.</p>
      <p v-if="showArchived" class="info">Listing degrees for the all academic years. Use the dropdowns to view a a plan for a specific year.</p>
    </div>


    <div class='listing-header-placeholder' :class='{"header-fixed": headerFixed }' ref='headerPlaceholder'></div>
    <div class='listing-header' :class='{"header-fixed": headerFixed, "is-unm": $store.getters.isUnmMain}' ref='header' v-if='!showArchived'>
      <div class='unit-content'>
        <div class='wrap'>
          <div class = 'unit-name'>
            <span>Level</span>
          </div>
          <div class = 'unit-level'>
            <span>Degree</span>
          </div>
          <div class = 'unit-availabitlity'>
            <span>Online</span>
          </div>
          <div class = 'unit-plans'>
            <span>Plan</span>
          </div>
          <div class = 'unit-credits'>
            <span>Credits</span>
          </div>
          <div class = 'header-button'>
            <span>Information</span>
          </div>
          <div class = 'header-button'>
            <span>Degree Plan</span>
          </div>
        </div>
      </div>
    </div>

    <div class='listing-header' :class='{"header-fixed": headerFixed, "is-unm": $store.getters.isUnmMain}' ref='header' v-else>
      <div class='unit-content'>
        <div class='wrap'>
          <div class = 'unit-name'>
            <span>Level</span>
          </div>
          <div class = 'unit-level'>
            <span>Degree</span>
          </div>
          <div class = 'header-button'>
            <span>Academic Period</span>
          </div>
        </div>
      </div>
    </div>

    <college
      v-for = 'college in nestedMajors'
      :college = 'college'
      :key = 'college.key'
    >
    </college>
  </div>
</template>

<script>
  import {nest, ascending} from 'd3'
  import College from './college.vue'

  export default {
    name: 'MajorList',

    data() {
    // get a sortable key by removing any 2+ character sets of capital
    // letters or any symbols. If all characters are removed, fallback to
    // original string. Also append first character so that programs starting
    // with AS come before those with BS.
      const sortKey = string => {
        return string[0] + string.replace(/[A-Z]{2,}|[ \-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/g, '') // eslint-disable-line no-useless-escape
      }

      const sortAscending = (a, b) => {
        return ascending(sortKey(a), sortKey(b))
      }

      return {
        headerFixed: false,
        nest: nest()
          .key(d => `${(d.college || {}).name}${(d.college || {}).code}`).sortKeys(ascending)
          .key(d => `${(d.program || {}).name}${(d.program || {}).code}`).sortKeys(sortAscending)
      }
    },

    props: {
      majors: {
        requred: true
      }
    },

    created() {
      window.addEventListener('scroll', this.headerFixedCheck)
    },

    beforeDestroy() {
      window.removeEventListener('scroll', this.headerFixedCheck)
    },

    computed: {
      currentPeriod() {
        return this.$store.getters.currentPeriod
      },

      showArchived() {
        return this.$store.state.showArchived
      },

      selectedProgramLevel() {
        return this.$store.state.selectedProgramLevel
      },

      programLevelMajors() {
        if (this.selectedProgramLevel === 'All') {
          return this.majors
        } else {
          return this.majors.filter(m => m.program_level && m.program_level.name === this.selectedProgramLevel)
        }
      },

      nestedMajors() {
        return this.nest.entries(this.programLevelMajors)
      }
    },

    methods: {
      toggleArchived() {
        this.$store.commit('setShowArchived', !this.showArchived)
      },

      headerFixedCheck() {
        this.headerFixed = this.$store.getters.isUnmMain
          ? this.$refs.headerPlaceholder.getBoundingClientRect().y < 70
          : this.$refs.headerPlaceholder.getBoundingClientRect().y < 50
      }
    },

    components: {
      College
    }
  }
</script>



// WEBPACK FOOTER //
// major_list.vue?45cf8a5f